<app-learninglab-header></app-learninglab-header>
<div class="container max-w-[1200px] py-16">
   <router-outlet></router-outlet>
</div>
